import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import { localizations } from '../localization/localization';
import { MapFilterInfo } from '../common/models/CommonModels';
import {showTruckRoutes, showDepartingArrivingUnits, showDepartingTrucks, showCompanies } from './RoutesState'

interface MapFilterProps {
    onFiltersChanged?: (filters: FilterPanelState) => void;
}
type FilterPanelState = MapFilterInfo;

class MapFilter extends React.Component<MapFilterProps, FilterPanelState>  {

    constructor(props: MapFilterProps) {
        super(props);

        this.state = {
            truckRoutes: showTruckRoutes,
            departingArrivingUnits: showDepartingArrivingUnits,
            departingTrucks: showDepartingTrucks,
            companies: showCompanies
        }
    }
    public render() {
        return <Grid container direction="row" spacing={2}>
            <Grid item>
                <FormLabel component="legend">{localizations.actions.showOnMapView} </FormLabel>
                <Grid item>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.departingTrucks}
                                onChange={this.handleChange('departingTrucks')}
                                value="departingTrucks"
                            />
                        }
                        label={localizations.map.checkbox.trucks}
                    />
                    {/* Left here just in case */}
                   {/*  <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.truckRoutes}
                                onChange={this.handleChange('truckRoutes')}
                                value="truckRoutes"
                            />
                        }
                        label={localizations.map.checkbox.routes}
                    /> */}
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.departingArrivingUnits}
                                onChange={this.handleChange('departingArrivingUnits')}
                                value="departingArrivingUnits"
                            />
                        }
                        label={localizations.map.checkbox.units}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.companies}
                                onChange={this.handleChange('companies')}
                                value="companies"
                            />
                        }
                        label={localizations.map.checkbox.companies}
                    />
                </Grid>

            </Grid>
        </Grid>
    }
    public handleChange = (name: any) => (event: any) => {
        this.setState({
            ...this.state,
            [name]: event.target.checked
        });

        const tempState = {
            ...this.state,
            [name]: event.target.checked
        };
        if (this.props.onFiltersChanged) {
            this.props.onFiltersChanged(tempState);
        }
    }
}

export default MapFilter;


// WEBPACK FOOTER //
// ./src/map/MapFilter.tsx